import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import colors from "assets/scss/_themes-vars.module.scss";

// material-ui
import { makeStyles, useTheme } from "@material-ui/styles";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import ColorSubCard from "./ColorSubCard";
import SubCard from "./SubCard";
import ToolTipHelper from "ui-component/ToolTipHelper";
import { tooltips } from "constants/tooltips";
// import CoinBaseLoginButton from "ui-component/CoinBaseLoginButton";
// style constant
const useStyles = makeStyles((theme) => ({
  revenueCard: {
    position: "relative",
    color: "#fff",
  },
  revenueIcon: {
    position: "absolute",
    right: "13px",
    top: "14px",
    color: "#fff",
    "&> svg": {
      width: "100px",
      height: "100px",
      opacity: "0.5",
    },
    [theme.breakpoints.down("xs")]: {
      top: "13px",
      "&> svg": {
        width: "80px",
        height: "80px",
      },
    },
  },
  card: {},
}));

// =============================|| REVENUE CARD ||============================= //

const SummaryCard = () => {
  const classes = useStyles();
  // const [timer, setTimer] = useState(Date.now() / 1000);
  const [revenue, setRevenue] = useState(0.0);
  //   const [cash, setCash] = useState(0.0);

  const theme = useTheme();
  const matchDownXs = useMediaQuery(theme.breakpoints.down("xs"));
  const cornsilk =
    theme.palette.mode === "dark"
      ? colors.cornsilkLightTakyon
      : colors.cornsilkDarkTakyon;
  const whiteTakyon =
    theme.palette.mode === "dark"
      ? colors.whiteLightTakyon
      : colors.whiteDarkTakyon;
  const green =
    theme.palette.mode === "dark"
      ? colors.successLightTakyon
      : colors.successDarkTakyon;
  const red =
    theme.palette.mode === "dark"
      ? colors.errorLightTakyon
      : colors.errorDarkTakyon;

  const [selectedExchange, exchanges] = useSelector((state) => [
    state.exchange.selectedExchange,
    state.exchange.exchanges,
  ]);

  let textc = "lightyellow";
  if (theme.palette.background.paper === "#ffffff") {
    textc = "darkred";
  }

  let unreal = useSelector((state) => {
    return Number(state.coins.newportfolio?.total_unreal || 0);
  });

  let fee = useSelector((state) => {
    return Number(state.coins.newportfolio?.total_fee || 0);
  });

  let total_balance = useSelector((state) => {
    return state.coins.newportfolio?.total_total || 0;
  });

  //   //TODO! CoinReducer: 392
  //   let total_balance = useSelector((state) => {
  //     let balance = 0;
  //     if (state.coins.kraken_asset_pairs !== undefined) {
  //       state.coins.kraken_asset_pairs.forEach((item) => {
  //         if (item.position !== undefined) {
  //           console.log("SummaryCard:" + item.position.balance);
  //           balance += item.position.balance * item.position.market_price;
  //         }
  //       });
  //       return Number(balance);
  //     } else {
  //       console.log("SC: asset_pairs === undefined");
  //       return Number(0);
  //     }
  //   });

  useEffect(() => {
    //i will update unly on 15 sec!
    if (total_balance !== 0) {
      let rev = Number(total_balance) + Number(unreal);
      setRevenue(rev);
      //   setCash(unreal);
      console.log(
        "SC: rev: " + rev + ", bal: " + total_balance + ", usd: " + unreal
      );
    }
  }, [total_balance, unreal]);

  return (
    <SubCard border={cornsilk}>
      <table style={{ align: "right" }}>
        <tr>
          <td>
            <font
              style={{
                textAlign: "right",
                fontWeight: "normal",
                spacing: "10px",
                "font-size": "2.0rem",
              }}
            >
              {" "}
              ${revenue}{" "}
            </font>
          </td>
          <td>
            <ToolTipHelper
              hover={tooltips.bal.hover}
              modal={tooltips.bal.modal}
            >
              <font
                style={{
                  color: textc,
                  textAlign: "right",
                  fontWeight: "normal",
                  spacing: "10px",
                  "font-size": "0.9rem",
                }}
              >
                {"bal"}
              </font>
            </ToolTipHelper>
          </td>
        </tr>
        <tr>
          <td style={{ textAlign: "right" }}>
            <font
              style={{
                textAlign: "right",
                fontWeight: "normal",
                spacing: "10px",
                "font-size": "1.0rem",
              }}
            >
              ${unreal}{" "}
            </font>
            <font
              style={{
                color: "gray",
                textAlign: "right",
                fontWeight: "normal",
                spacing: "10px",
                "font-size": "0.9rem",
              }}
            >
              {" "}
              {((unreal * 100) / revenue).toFixed(0)}
              {"% "}
            </font>
          </td>
          <td>
            <font
              style={{
                color: textc,
                textAlign: "right",
                fontWeight: "normal",
                spacing: "10px",
                "font-size": "0.7rem",
              }}
            >
              {"USD"}
            </font>
          </td>
          <td>
            <font
              style={{
                color: textc,
                textAlign: "right",
                fontWeight: "normal",
                spacing: "10px",
                "font-size": "0.7rem",
              }}
            >
              ${fee}
            </font>
          </td>
          <td>
            <font
              style={{
                color: textc,
                textAlign: "right",
                fontWeight: "normal",
                spacing: "10px",
                "font-size": "0.7rem",
              }}
            >
              {"Fee"}
            </font>
          </td>
        </tr>
      </table>
    </SubCard>
    /*
            <>
                <font style={{color: 'gray', textAlign: 'middle', fontWeight: 'normal', spacing: "10px", "font-size": "1.0rem" }} className={classes.secondary}> 
                    {'Portfolio'}
                </font>
                <font style={{textAlign: 'middle', fontWeight: 'normal', spacing: "10px", "font-size": "2.0rem" }} className={classes.secondary}> 
                    {revenue} 
                </font>
           </>
            */
  );
};

SummaryCard.propTypes = {
  content: PropTypes.string,
  color: PropTypes.string,
};

export default SummaryCard;
